import { useSelector } from "react-redux";

export const useClientSelectors = () => ({
  info: useSelector(state => state.client.anonymityInfo),
});
